export default "__VITE_ASSET__225d5285__"